import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { TypeOf } from "yup";
import { postSaga } from "../../request/post";
import { SagaActionParams, SagaGenericParams } from "../../request/types";
import { LoginResponseDto } from "./types";

export const loginAction = createAction(
  "LOGIN_ACTION",
  ({ payload, body }: SagaActionParams<LoginResponseDto>) => ({
    payload,
    url: "/api/appuser/admin/login",
    body,
  })
);
export const forgotPassword = createAction(
  "FORGOT_PASSWORD",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    url: "/api/appuser/send-password-reset-token",
    body,
  })
);

export const resetPassword = createAction(
  "RESET_PASSWORD",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    url: "/api/appuser/reset-password",
    body,
  })
);
const authSaga = [
  takeLatest<any>(
    loginAction.toString(),
    (payload: SagaGenericParams<LoginResponseDto>) =>
      postSaga<LoginResponseDto>(payload)
  ),
  takeLatest<any>(
    forgotPassword.toString(),
    (payload: SagaGenericParams<any>) => postSaga<any>(payload)
  ),
  takeLatest<any>(resetPassword.toString(), (payload: SagaGenericParams<any>) =>
    postSaga<any>(payload)
  ),
];

export default authSaga;
